import {api} from '../../../helpers/helpers';
import {auth} from '../../../helpers/firebase';

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Get auth headers with Firebase token
 */
async function getAuthHeaders() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }

  const token = await user.getIdToken();
  return {
    'x-auth-token': token,
    'Content-Type': 'application/json'
  };
}

/**
 * Get current user info
 */
export async function getCurrentUser() {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/user/me`,
    method: 'GET',
    options: {headers}
  });
}

/**
 * Get users by team name
 */
export async function getUsersByTeamName(teamName) {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/team/users?teamName=${teamName}`,
    method: 'GET',
    options: {headers}
  });
}

/**
 * Get all users
 */
export async function getUsers() {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/users`,
    method: 'GET',
    options: {headers}
  });
}

/**
 * Get user by ID
 */
export async function getUserById(id) {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/users/${id}`,
    method: 'GET',
    options: {headers}
  });
}

/**
 * Create new user
 */
export async function createUser(userData) {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/users`,
    method: 'POST',
    data: userData,
    options: {headers}
  });
}

/**
 * Update user
 */
export async function updateUser(id, userData) {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/users/${id}`,
    method: 'PUT',
    data: userData,
    options: {headers}
  });
}

/**
 * Delete user
 */
export async function deleteUser(id) {
  const headers = await getAuthHeaders();

  return api({
    url: `${API_BASE_URL}/api/users/${id}`,
    method: 'DELETE',
    options: {headers}
  });
}
